import React from 'react';
import { motion } from 'framer-motion';
import './style.css'

const CustomSortButton = ({ onSortChange, currentSortOrder }) => {
    const handleSortToggle = () => {
        const newSortOrder = currentSortOrder === 'latest' ? 'oldest' : 'latest';
        onSortChange(newSortOrder);
    };

    return (
        <div className="custom_sort_button_container">
            <button
                className="custom_sort_button"
                onClick={handleSortToggle}
            >
        <span className="custom_sort_button_text">
          Sort Templates: {currentSortOrder === 'latest' ? 'Latest First' : 'Oldest First'}
        </span>
                <motion.div
                    className="custom_sort_button_icon"
                    animate={{ rotate: currentSortOrder === 'latest' ? 0 : 180 }}
                    transition={{ duration: 0.3 }}
                >
                    {currentSortOrder === 'latest' ? '↓' : '↑'}
                </motion.div>
            </button>
        </div>
    );
};

export default CustomSortButton;